import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { getScreenHeight } from '../utils/breakpoints'
import { getSmoothScroll } from '../scroll-smoother'

function init() {

  const block = document.querySelector('.block-history')

  if(!block) return false

  const triggerElement = block.querySelector('.content')

  ScrollTrigger.create({
    trigger: block,
    pin: triggerElement,
    top: 'top top',
    end: 'bottom bottom',
    scrub: true,
    //markers: true
  })

  const gridItems = block.querySelectorAll('.grid-item')

  gridItems.forEach((item, key) => {

    let data = {
      startAt: { rotationX: 50, scale: 0.7 },
      scale: 1,
      rotationX: -50,
      trigger: {
        start: 'top bottom',
        end: 'bottom top'
      }
    }

    if(key < 3) {
      data.startAt = { rotationX: 0, scale: 0.85 }
    }

    if(key > 5) {
      data.rotationX = 0
    }

    gsap.timeline()
      .to(item, {
        ease: 'none',
        startAt: data.startAt,
        scale: data.scale,
        rotationX: data.rotationX,
        scrollTrigger: {
          trigger: item.querySelector('.background-image'),
          start: data.trigger.start,
          end: data.trigger.end,
          // markers: true,
          scrub: true,
        }
      });
  })

}

init()
